<template>
    <drawer title="Select a page">
        <template v-slot:header-primary>
            <!-- <drawer-search /> -->
        </template>

        <navigation-tree
            item-type="content"
            :is-content-select="true"
            :hide-ellipses="true"
        >
            <template #meta-content>
                <favorites @selected="onClose" />
            </template>
        </navigation-tree>
    </drawer>
</template>

<script>
import { mapMutations } from 'vuex';

import NavigationTree from '@/components/page-editor/navigation-tree/navigation-tree';
import Favorites from '@/components/page-editor/favorites';
import Drawer from '@/components/shared/drawer/drawer';
import { HIDE_DRAWER } from '@/store/types/mutation-types';

export default {
    components: {
        NavigationTree,
        Favorites,
        Drawer,
    },

    methods: {
        ...mapMutations({
            hideDrawer: HIDE_DRAWER,
        }),

        onClose() {
            this.hideDrawer();
        },
    },
};
</script>
